const DEVICE_ID_KEY = 'shep_device_id_v2';
const LEGACY_KEYS = ['shep_device_id', 'deviceId', 'deviceSig'];

const normalize = (value) => {
  const clean = String(value || '').trim();
  return /^(?:[a-f0-9-]{20,128})$/i.test(clean) ? clean : '';
};

const randomId = () => {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();

  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex
    .slice(6, 8)
    .join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
};

/**
 * A browser cannot expose a real hardware ID. This creates one installation ID
 * and keeps it stable across refresh, login, logout and tabs for this browser
 * profile. It intentionally does not use public IP, user-agent or screen size.
 */
export const getStableDeviceId = () => {
  if (typeof window === 'undefined') return '';

  let value = normalize(localStorage.getItem(DEVICE_ID_KEY));

  if (!value) {
    for (const key of LEGACY_KEYS) {
      value = normalize(localStorage.getItem(key));
      if (value) break;
    }
  }

  if (!value) value = randomId();

  localStorage.setItem(DEVICE_ID_KEY, value);
  localStorage.setItem('shep_device_id', value);
  localStorage.setItem('deviceId', value);
  localStorage.setItem('deviceSig', value);
  sessionStorage.setItem('deviceId', value);
  sessionStorage.setItem('deviceSig', value);

  return value;
};

// Compatibility for the existing Home component.
export const getStableMachineId = async () => ({
  id: getStableDeviceId(),
  fingerprint: {
    kind: 'persistent-browser-installation-id',
    platform: navigator.platform || null,
  },
});

export default getStableDeviceId;

